var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pt-2" }, [
    _c(
      "div",
      { staticClass: "flex flex-row items-center  justify-end" },
      [
        _c("small", { staticClass: "text-muted mr-1" }, [
          _vm._v(_vm._s(_vm.textLabel) + ":")
        ]),
        _c(
          "b-link",
          { attrs: { href: "https://securamdata.com", target: "_brank" } },
          [_vm._v("securamdata.com")]
        )
      ],
      1
    ),
    _vm.showLoginLink
      ? _c(
          "div",
          { staticClass: "flex flex-row justify-end items-center pt-1" },
          [
            _c(
              "div",
              { staticClass: "btn btn-outline-primary btn-sm" },
              [
                _c("b-link", { attrs: { href: "/", target: "_self" } }, [
                  _vm._v(_vm._s(_vm.$t("login")))
                ])
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }